// extracted by mini-css-extract-plugin
module.exports = {"root":"EditVenueExtrasPanel_root__q49HT","form":"EditVenueExtrasPanel_form__27bw2","title":"EditVenueExtrasPanel_title__qbhmn","priceHint":"EditVenueExtrasPanel_priceHint__18cDK"};